import { render } from "./MultiSelect.vue?vue&type=template&id=35d1245e&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=35d1245e&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d1245e"]])

export default __exports__